import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="lg:w-1/2">
            <div className="rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20bright%20workspace%20with%20organized%20product%20samples%20neatly%20arranged%20on%20warm%20oak%20desk%20alongside%20laptop%20showing%20interface%2C%20soft%20natural%20diffused%20daylight%20from%20large%20window%2C%20minimalist%20aesthetic%2C%20editorial%20photography%2C%20warm%20neutral%20tones%20with%20subtle%20sage%20green%20plant%20accents%2C%20no%20text%20or%20logos%20visible%2C%20clean%20calm%20and%20professional%20composition%20with%20thoughtful%20organization&width=700&height=525&seq=whatis-img-v2&orientation=landscape"
                alt="What is itaobuy spreadsheet - organized sourcing workspace"
                title="What is Itaobuy Spreadsheet System"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              What is Itaobuy Spreadsheet?
            </h2>
            <div className="mt-6 space-y-4 text-foreground-700 text-base leading-relaxed">
              <p>
                <strong>Itaobuy spreadsheet</strong> is a structured product sourcing system that allows users to browse, compare, and purchase products from Chinese marketplaces through an organized spreadsheet format.
              </p>
              <p>
                Instead of searching manually on Taobao or 1688, users can view curated product lists, compare prices instantly, understand shipping and service fees, and place orders more efficiently.
              </p>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3">
              {[
                'Curated Product Lists',
                'Instant Price Comparison',
                'Transparent Shipping Fees',
                'Efficient Order Processing',
              ].map((item) => (
                <div key={item} className="flex items-center gap-2">
                  <i className="ri-check-line w-4 h-4 flex items-center justify-center text-accent-500"></i>
                  <span className="text-sm text-foreground-700">{item}</span>
                </div>
              ))}
            </div>
            <Link
              to="/article/what-is-itaobuy-spreadsheet"
              className="inline-flex items-center gap-2 mt-7 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Read Full Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}